/* ft-mehr.js (14.10.2026 nachts, Sitzung Webshop, nur Testshop; Design-Bauplan 3.5 „Weitere laden“).
   Der Knopf „Weitere 48 laden“ (snippets/ft-seitenzahlen) ist ein Link auf die nächste Seite. Mit Skript holt er stattdessen nur den
   Abschnitt der nächsten Seite (Section Rendering API, ?section_id=…), hängt dessen Karten an #ft-prod-grid an und zählt weiter
   („96 von 6.505 Artikeln“). Nach „Zurück“ von einem Artikel lädt er dieselben Seiten erneut und springt an die alte Stelle
   (sessionStorage je Adresse; kommt die Seite aus dem Browser-Zwischenspeicher, steht ohnehin alles noch da).
   Danach: Liefertermine (FtEta), Ereignis „ft-karten-neu“; snippets/ft-karten-passung beobachtet die Liste selbst. */
(function () {
  if (window.FtMehr) return;
  window.FtMehr = true;
  var nav = document.querySelector('[data-ft-mehr]');
  var grid = document.getElementById('ft-prod-grid');
  if (!nav || !grid || !window.fetch || !window.DOMParser) return;
  var abschnitt = nav.getAttribute('data-abschnitt') || '';
  var gesamt = +nav.getAttribute('data-gesamt') || 0;
  var start = +nav.getAttribute('data-start') || 0;
  var proSeite = +nav.getAttribute('data-seite') || 48;
  var stand = nav.querySelector('[data-ft-mehr-stand]');
  var SCHLUESSEL = 'ft-mehr:' + location.pathname + location.search;
  var extra = 0, laeuft = false;

  function zahl(n) { return Number(n).toLocaleString('de-DE'); }
  function knopf() { return nav.querySelector('[data-ft-mehr-knopf]'); }
  function gezeigt() { return start + grid.querySelectorAll(':scope > .ft-pc').length; }
  function schreiben() {
    var n = Math.min(gezeigt(), gesamt);
    if (stand) stand.textContent = zahl(n) + ' von ' + zahl(gesamt) + ' Artikeln';
    var k = knopf();
    if (k) k.textContent = 'Weitere ' + Math.min(proSeite, Math.max(gesamt - n, 0)) + ' laden';
  }
  function merken() {
    try { sessionStorage.setItem(SCHLUESSEL, JSON.stringify({ extra: extra, y: window.scrollY || 0 })); } catch (e) {}
  }
  function laden(url) {
    var u = url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(abschnitt);
    return fetch(u, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Status ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neu = doc.getElementById('ft-prod-grid');
      var karten = neu ? neu.querySelectorAll(':scope > .ft-pc') : [];
      for (var i = 0; i < karten.length; i++) grid.appendChild(document.importNode(karten[i], true));
      var weiter = doc.querySelector('[data-ft-mehr-knopf]');
      var k = knopf();
      if (k) {
        if (weiter && karten.length) k.setAttribute('href', weiter.getAttribute('href'));
        else k.parentNode.removeChild(k);
      }
      extra++;
      schreiben();
      if (window.FtEta && window.FtEta.fill) window.FtEta.fill();
      try { document.dispatchEvent(new CustomEvent('ft-karten-neu', { detail: { anzahl: karten.length } })); } catch (e) {}
      return karten.length;
    });
  }
  nav.addEventListener('click', function (e) {
    var k = e.target.closest('[data-ft-mehr-knopf]');
    if (!k || !abschnitt || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (laeuft) return;
    laeuft = true;
    k.setAttribute('aria-busy', 'true');
    var vorher = k.textContent;
    k.textContent = 'Wird geladen';
    laden(k.getAttribute('href')).catch(function () {
      /* Fehler oder gedrosselt (429): normal zur nächsten Seite wechseln */
      location.href = k.getAttribute('href');
    }).then(function () {
      laeuft = false;
      var k2 = knopf();
      if (k2) { k2.removeAttribute('aria-busy'); if (k2.textContent === 'Wird geladen') k2.textContent = vorher; }
      merken();
    });
  });
  window.addEventListener('pagehide', merken);

  /* Zurück von einem Artikel: dieselben Seiten nachladen und an die alte Stelle springen */
  var alt = null;
  try { alt = JSON.parse(sessionStorage.getItem(SCHLUESSEL) || 'null'); } catch (e) {}
  var nav0 = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  var zurueck = nav0 && nav0.type === 'back_forward';
  if (!zurueck) {
    try { sessionStorage.removeItem(SCHLUESSEL); } catch (e) {}
  } else if (alt && alt.extra > 0) {
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    var n = 0;
    (function weiter() {
      var k = knopf();
      if (n >= alt.extra || !k) { window.scrollTo(0, alt.y || 0); return; }
      n++;
      laden(k.getAttribute('href')).then(weiter, function () { window.scrollTo(0, alt.y || 0); });
    })();
  }
  schreiben();
})();
